import {useState, useCallback} from 'react';
import {Box, Typography, Button} from "@mui/material";

import ResponsiveAppBar from "../assets/components/ResponsiveAppBar.tsx";
import ContactForm from "../assets/components/ContactForm.tsx";
import ContactFooter from "./ContactFooter.tsx";
import Footer from "./Footer.tsx";
import {locationsByState} from "../data/schoolLocations.ts";

function LetsTalk() {
    const [selectedSchool, setSelectedSchool] = useState<string | null>(null);

    const handleSchoolChange = useCallback((schoolKey: string | null) => {
        setSelectedSchool(schoolKey);
    }, []);

    // Show tour box if no school selected OR if selected school has tourSchedulingEnabled
    const shouldShowTourBox = () => {
        if (!selectedSchool) return true;

        for (const locations of Object.values(locationsByState)) {
            const school = locations.find(loc => loc.schoolKey === selectedSchool);
            if (school) {
                return school.tourSchedulingEnabled === true;
            }
        }
        return true; // Default to showing if school not found
    };
    return (
        <>
            <Box sx={{}}>
                <ResponsiveAppBar/>
                <Box className={'tile'} sx={{mb:20,}}>
                    <br/>
                    <Box sx={{display:'flex', flexDirection:{xs: 'column-reverse', md:'row'}, justifyContent: shouldShowTourBox() ? 'flex-start' : 'center'}}>
                        <Box sx={{mr: shouldShowTourBox() ? {md:5, xs:0} : 0, mt:5}}>
                            <ContactForm onSchoolChange={handleSchoolChange}/>
                        </Box>
                        {shouldShowTourBox() && (
                            <Box sx={{
                                maxWidth:'90vw',
                                ml:'auto',
                                mr:'auto',
                                display: 'flex',
                                flexDirection: 'column',
                                alignItems: 'center',
                                justifyContent: 'center',
                                gap: 3,
                                p: 4,
                                backgroundColor: 'rgba(255, 255, 255, 0.7)',
                                borderRadius: 3,
                                minHeight: '400px'
                            }}>
                                <Typography sx={{
                                    marginTop:'unset',
                                    textAlign:'center',
                                    fontSize:{md:'4rem', xs:'2.5rem',},
                                    fontWeight:'900'
                                }}>
                                    Ready to tour?
                                </Typography>
                                <Typography sx={{
                                    textAlign:'center',
                                    fontSize:{md:'1.5rem', xs:'1.2rem',},
                                    color: 'text.secondary',
                                    maxWidth: '500px'
                                }}>
                                    Schedule a personalized tour of one of our schools and see what makes Prodigy special!
                                </Typography>
                                <Button
                                    variant="contained"
                                    size="large"
                                    href="/schedule-tour"
                                    sx={{
                                        fontSize: {md: '1.5rem', xs: '1.2rem'},
                                        py: 2,
                                        px: 4,
                                        borderRadius: '15px',
                                        mt: 2
                                    }}
                                >
                                    Schedule a Tour
                                </Button>
                            </Box>
                        )}

                    </Box>
                </Box>
                <ContactFooter/>
                <Footer/>
            </Box>
        </>
    );
}

export default LetsTalk
